import React, { MouseEventHandler } from "react";

import { formatNumber, useGetFieldShape, useTranslation } from "utils";

import { FieldListField } from "models";

import { Card, Checkbox, Icon, MapStatic, Typography } from "components";

type FieldListCardProps = {
  field: FieldListField;
  isSelected: boolean;
  onSelectionChange: MouseEventHandler;
  dataTestId?: string;
  disabled?: boolean;
};

export const FieldListCard = ({ field, isSelected, onSelectionChange, dataTestId = "", disabled }: FieldListCardProps) => {
  const { t } = useTranslation("farm");
  const { fieldShape, fieldShapeLoading } = useGetFieldShape({ fieldId: field.id });

  return (
    <Card
      className={`field-selection-card${disabled ? " disabled" : ""}`}
      dataTestId={`${dataTestId ? `${dataTestId}-` : ""}field-selection-card`}
      mixpanelText="field-card"
      loading={fieldShapeLoading}
    >
      <div className="field-selection-card-content" onClick={onSelectionChange}>
        <div className="map-container">
          {/* @ts-expect-error need to convert this to TS */}
          <MapStatic field={field} geometry={fieldShape} location={field.location} />
        </div>
        <div className="field-details">
          <div className="name">
            <Typography variant="paragraph-m" bold color={field.name ? undefined : "red-500"}>
              {field.name || t("unknownFieldName")}
            </Typography>
          </div>
          <div className="size">
            <Typography variant="paragraph-s" color="grey-600">
              <Icon iconName="klim/field-size" className="icon inline" />
              {formatNumber({ number: field.size })}ha
            </Typography>
          </div>
        </div>
        <div className="checkbox-container">
          <Checkbox checked={isSelected} disabled={disabled} />
        </div>
      </div>
    </Card>
  );
};
